import React from 'react';
import { Box, Image } from '@chakra-ui/react';
import knicksLogoPng from '../static/knicks-logo-400px.png';

const Logo = () => (
  <div className="leaflet-top leaflet-left">
    <Box className="leaflet-control">
      <Image
        src={knicksLogoPng}
        alt="Logo"
        boxSize={['10rem', '11rem', '12rem', '13rem']}
        height="auto !important"
        fit="scale-down"
        align="top"
        userSelect="none"
      />
    </Box>
  </div>
);

export default Logo;
